export default __webpack_public_path__ + "static/media/82.aa886a57.svg";